import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ContinueButton } from 'page/ProfileScreen/BasicSelfiesPanel/ContinueButton'
import { GenderSelect } from 'page/ProfileScreen/BasicSelfiesPanel/GenderSelect'
import { store } from 'store/store'

export const SecondStep = observer(() => {
  const canContinue = !!store.profile.basic.gender

  const onContinue = useLatestCallback(async () => {
    store.profile.basic.step = 'third'
  })

  return (
    <Vertical>
      <Vertical>
        <Typo size={24} tertiary upper center>
          {i18n('StepCount', { count: 2 })}
        </Typo>
        <Typo size={32} medium upper center>
          {i18n('ChooseGender')}
        </Typo>
      </Vertical>
      <Gap height={80} />
      <GenderSelect />
      <Gap height={120} />
      <ContinueButton disabled={!canContinue} action={onContinue} />
    </Vertical>
  )
})
